import React from 'react';
import {
  ChakraProvider
} from '@chakra-ui/react';
import theme from './theme';
import AccountManager from './pages/AccountManager';

function App({ dashboardDataset }) {
  return (
    <ChakraProvider theme={theme}>
      <div className='page-layout'>
        <AccountManager dashboardDataset={dashboardDataset} />
      </div>
    </ChakraProvider>
  );
}

export default App;
